import { z } from 'zod';
import { personSchema } from './person';

/** Who is signed in on this device, as kept in localStorage. */
export const storedSessionSchema = z.object({
  user: personSchema,
  people: z.array(personSchema),
  server_id: z.string(),
  /** The server refused the token: local work goes on, sync waits for a new sign-in. */
  expired: z.boolean().optional(),
});

export type StoredSession = z.infer<typeof storedSessionSchema>;
